export function uploadToObs(
  url: string,
  file: File,
  onProgress?: (progress: number) => void
) {
  return new Promise<void>((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('PUT', url);

    // 猜测：后端生成OBS签名时 Content-Type 为空; 这里必须保持一致，否则会 403
    xhr.setRequestHeader('Content-Type', '');

    xhr.upload.onprogress = event => {
      if (!event.lengthComputable) return;

      const percent = Math.floor((event.loaded / event.total) * 100);
      onProgress && onProgress(percent);
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
      } else {
        reject(new Error('OBS 上传失败'));
      }
    };

    xhr.onerror = () => reject(new Error('OBS 上传失败'));

    xhr.send(file);
  });
}